import { Box, BoxProps } from '@mui/material';
import {
	sectionGap,
	stackedClassName
} from 'components/MDRenderer/elements/mdConsts';
import React from 'react';

/**
 * This component can be used with MDRenderer to insert a gap above elements if
 * said elements do not reside within a container that is already spaces them.
 */
const MDGapWrapper: React.FC<BoxProps> = ({ sx, ...rest }) => (
	<Box
		data-testid="md-gap-wrapper"
		{...rest}
		sx={{
			[`:not(.${stackedClassName} > &)`]: {
				mt: sectionGap
			},
			...sx
		}}
	/>
);

export default MDGapWrapper;
